import { useState, useEffect } from 'react';
import Modal from "react-bootstrap/Modal";
export const Payhinga = () => {
    const payhingaLinkText = process.env.REACT_APP_VAS_PAYHINGA_LINK_TEXT;
    const [payhingaPopup, setPayhingaPopup] = useState(false);
    const [payhingaDisableButton, setPayhingaDisableButton] = useState(false);
    const [modalContent, setModalContent] = useState(""); // Add this line
    const payhingaPopupShow = () => {
        setPayhingaPopup(true);
    };
    const payhingaPopupClose = () => {
        setPayhingaPopup(false);
    };


    useEffect(() => {
        // Fetch your static HTML content here
        fetch("/Payhinga.html")
          .then((response) => {
            //  alert(response); // This alerts the response object
            return response.text(); // Return the text content of the response
          })
          .then((content) => {
            //console.log('content:', content);
            setModalContent(content);
          })
          .catch((error) => console.error("Error fetching HTML content:", error));
      }, []);

    return (
        <>
            <span
                className="tonik-color"
                onClick={payhingaPopupShow}
                disabled={payhingaDisableButton}
                style={{ cursor: "pointer", fontWeight: "600" }}
            >
                <span>{payhingaLinkText}</span>
            </span>
            <Modal
                windowclass="modal-rounded"
                show={payhingaPopup}
                onHide={payhingaPopupClose}
                animation={false}
                style={{ marginTop: "-60px" }}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body
                    style={{
                        backgroundColor: "#f7f7f8",
                        width: "100%",
                        maxHeight: "70vh",
                        overflowY: "auto",
                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: modalContent }} />
                </Modal.Body>
                <Modal.Footer
                    style={{
                        color: "white",
                        backgroundColor: "#f7f7f8",
                        width: "100%",
                        borderTop: "none",
                    }}
                >
                    {/* Add your modal footer content here */}
                </Modal.Footer>
            </Modal></>
    );
};

export default Payhinga;